import { isPublic } from '@core/router/utils';
// import { Auth } from '@core/auth';

const preload = async (to, from, next) => {
    if (isPublic(to)) {
        next();
    } else {
        // if (Auth().is_adviser) {
        //     // Preload data to vuex
        // }

        next();
    }
};

export default preload;
